import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Container, Grid, Typography } from "@material-ui/core";
import FondoCredencial from '../../../assets/Fondo_Credencial.png'
import { useDispatch, useSelector } from "react-redux";
import { getCredenciales } from "../../../actions/webAfiliado/afiliadoVariosAction";
import LoadingBeforeViewData from "../../compartidos/LoadingBeforeViewData";
import { jsPDF } from "jspdf";
import html2canvas from 'html2canvas';
import { finishSpinner, startSpinner } from "../../../actions/ui/spinner";
import CardCredencial from "./CardCredencial";
import { cargarEstadisticas } from "../../../actions/miOspedyc/estadisticasMiOspedyc";
import { ESTADISTICAS_OSPEDYC } from "../../../utils/constants";
import { Link } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
    root: {
        minHeight: '100%',
        marginTop: "1.5rem",
        marginBottom: "1rem"
    },
    title: {
        fontWeight: "bold"
    },
    card: {
        marginTop: "1rem",
        marginBottom: "1rem",
        position: "relative"
    },
    cardIn: {
        borderRadius: 15,
        backgroundImage: `url(${FondoCredencial})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        padding: "0px",
        [theme.breakpoints.up('sm')]: {
            padding: '1rem',
        },
    },
    logoContainer: {
        textAlign: "left"
    },
    logoCard: {
        width: "50%"
    },
    titleCredencial: {
        fontWeight: "bold",
        color: "#fff",
        marginRight: 5
    },
    numberCredencial: {
        color: "#fff"
    },
    containerBody: {
        marginTop: "1rem"
    },
    centerTextBody: {
        display: "flex",
        alignItems: "center"
    },
    containerTextVencida: {
        backgroundColor: "rgba(255, 0, 0, 0.9)",
        position: "absolute",
        top: 1,
        right: 15
    },
    textVencida: {
        textAlign: "right",
        color: "#fff",
        fontWeight: "bold",
        fontSize: 11,
        padding: 2
    },
}));

const Credenciales = (props) => {
    
    const classes = useStyles();
    const dispatch = useDispatch()
    const { credenciales } = useSelector(state => state.afiliadoVarios)

    const  printDocument=(idPrint) =>{
        dispatch(startSpinner())
        const input = document.getElementById(idPrint);
        html2canvas(input)
          .then((canvas) => {
            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF();
            pdf.addImage(imgData, 'JPEG', 0, 0);
            // pdf.output('dataurlnewwindow');
            pdf.save("credenciales.pdf");
            dispatch(finishSpinner())
          }).catch(e=>{
              console.log("Error al generar pdf")
              dispatch(finishSpinner())
          })
        ;
      }
    useEffect(() => {
        dispatch(getCredenciales())
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        dispatch(cargarEstadisticas(ESTADISTICAS_OSPEDYC.CREDENCIAL))
        // eslint-disable-next-line
    }, [])

    if (credenciales === null) {
        return <LoadingBeforeViewData />
    }
    
    return (
        <div className={classes.root}>
            <Container maxWidth="md">
                <Typography align="center" variant="h4" color="primary" className={classes.title}>Credencial digital</Typography>
                <Typography align="center" color="secondary">A continuación, podrás ver tus credenciales.</Typography>
                <Typography align="center" variant="subtitle2" style={{cursor:"pointer", color:"#0095ff"}} onClick={()=>printDocument('containerCredenciales')}>- Descargalas haciendo click aquí -</Typography>
                <Typography align="center" style={{fontSize:'0.70rem'}}>* En caso de no visualizar su credencial por favor comuníquese con Ospedyc <Link to="/afiliado/contactos">aquí</Link></Typography>
                <Grid
                    container
                    direction="row"
                    alignItems="center"
                    style={{ paddingTop: "1rem" }}
                    id="containerCredenciales"
                >
                    <Grid item>
                    {
                        credenciales.map(credencial => {
                            return (
                                <CardCredencial key={credencial.numero} credencial={credencial} />
                            )
                        })
                    }

                </Grid>
                </Grid>
            </Container>
        </div>
    );
};

export default Credenciales
